// Trace drawer styles (WEB-8004) — run traces, tool-call rows and the
// proposal cards (ws-prop-card / ws-trace-proposal-list). NOTE: the account
// dashboard's DashboardAiSuggestions renders those proposal cards too — any
// per-surface pruning must keep this fragment in its composition.
// Composed by workspaceStyles.ts in place.
export const traceDrawer = `
/* ===== Trace drawer ===== */
.ws-trace-backdrop {
  position: fixed; inset: 0; background: rgba(19,17,14,0.32);
  z-index: 9990; backdrop-filter: blur(2px);
}
.ws-trace-drawer {
  position: fixed; top: 0; right: 0; bottom: 0;
  min-width: 400px; max-width: 85vw;
  background: var(--ws-panel); border-left: 1px solid var(--ws-line);
  box-shadow: var(--ws-shadow-lg); z-index: 9991;
  display: flex; flex-direction: column; overflow: hidden;
}
.ws-trace-drawer.is-resizing { transition: none; user-select: none; }
.ws-trace-resize-handle {
  position: absolute; top: 0; left: -3px; bottom: 0; width: 7px;
  cursor: col-resize; z-index: 3;
  background: transparent;
}
.ws-trace-resize-handle::after {
  content: ''; position: absolute; top: 0; left: 3px; bottom: 0; width: 1px;
  background: transparent; transition: background 120ms ease;
}
.ws-trace-resize-handle:hover::after,
.ws-trace-drawer.is-resizing .ws-trace-resize-handle::after {
  background: var(--ws-info);
}
.ws-trace-header {
  display: flex; flex-direction: column; gap: 6px;
  padding: 12px 20px; border-bottom: 1px solid var(--ws-line);
  position: sticky; top: 0; z-index: 2;
  background: var(--ws-panel);
}
.ws-trace-header-top {
  display: flex; align-items: center; gap: 8px;
}
.ws-trace-pill--id {
  font-family: var(--ws-mono); font-size: 11px; font-weight: 500;
  color: var(--ws-ink-3); background: var(--ws-soft);
  padding: 2px 8px; border-radius: 999px;
  border: 1px solid var(--ws-line);
}
.ws-trace-status {
  font-size: 11px; padding: 2px 8px; border-radius: 999px;
  background: var(--ws-soft); color: var(--ws-ink-3); text-transform: capitalize;
  border: 1px solid var(--ws-line);
}
.ws-trace-status-needs-reply { background: #FFF3E0; color: #E65100; border-color: rgba(230,81,0,0.2); }
.ws-trace-status-needs-approval { background: #FFF3E0; color: #E65100; border-color: rgba(230,81,0,0.2); }
.ws-trace-status-blocked { background: #FFEBEE; color: var(--ws-err); border-color: rgba(184,74,62,0.2); }
.ws-trace-status-requeued { background: #E8F5E9; color: #2E7D32; border-color: rgba(46,125,50,0.2); }
.ws-trace-status-running { background: #E8F5E9; color: #2E7D32; border-color: rgba(46,125,50,0.2); }
.ws-trace-status-live {
  display: inline-flex; align-items: center; gap: 5px;
  background: rgba(59,107,168,0.08); color: var(--ws-info);
  border-color: rgba(59,107,168,0.25);
}
.ws-trace-live-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: var(--ws-info); flex-shrink: 0;
  animation: ws-pulse 1.5s ease-in-out infinite;
}
@keyframes ws-pulse {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(59,107,168,0.5); }
  50% { opacity: 0.7; box-shadow: 0 0 0 4px rgba(59,107,168,0); }
}
.ws-trace-meta-time {
  font-size: 11.5px; color: var(--ws-ink-3); font-variant-numeric: tabular-nums;
  margin-left: 4px;
}
.ws-trace-header-actions {
  margin-left: auto;
  display: inline-flex; align-items: center; gap: 2px;
}
.ws-trace-header-action {
  background: transparent; border: 0;
  cursor: pointer; padding: 4px; border-radius: 4px; color: var(--ws-ink-3);
  display: inline-flex; align-items: center; justify-content: center;
}
.ws-trace-header-action:hover { background: var(--ws-hover); color: var(--ws-ink-2); }
.ws-trace-title {
  font-family: var(--ws-serif); font-size: 18px; font-weight: 500;
  margin: 0; line-height: 1.3; letter-spacing: -0.01em;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  flex: 1; min-width: 0;
}
.ws-trace-title-placeholder { flex: 1; min-width: 0; }
.ws-trace-header-meta {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
}
.ws-trace-body { flex: 1; overflow-y: auto; scrollbar-gutter: stable; padding: 10px 20px 18px; }
.ws-trace-meta-inline {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  font-size: 13px; color: var(--ws-ink-3);
}
.ws-trace-meta-sep { color: var(--ws-ink-4); }
.ws-trace-meta-label { color: var(--ws-ink-4); }
.ws-trace-origin {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 8px; margin-top: 2px;
  background: var(--ws-soft); border: 1px solid var(--ws-line);
  border-radius: 999px;
  font-family: var(--ws-sans); font-size: 12px; color: var(--ws-ink-3);
  cursor: pointer; transition: background 120ms ease, color 120ms ease;
  align-self: flex-start;
}
.ws-trace-origin:hover:not(:disabled) { background: var(--ws-hover); color: var(--ws-ink-1); }
.ws-trace-origin:disabled { cursor: default; opacity: 0.7; }
.ws-trace-origin-label { color: var(--ws-ink-4); }
.ws-trace-origin-name { font-weight: 500; color: var(--ws-ink-2); }
.ws-trace-summary {
  margin: 0 0 16px; background: #FEF6EE; border: 1px solid rgba(184,112,42,0.2);
  border-radius: var(--ws-r-md); padding: 14px 16px;
}
.ws-trace-section-head {
  font-size: 11px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.06em; color: var(--ws-ink-4); margin-bottom: 8px;
}
.ws-trace-summary .ws-trace-section-head { margin-bottom: 6px; }
.ws-trace-summary p { margin: 0; font-size: 13.5px; line-height: 1.55; color: var(--ws-ink-2); white-space: pre-wrap; }
.ws-trace-summary-muted { color: var(--ws-ink-4) !important; font-style: italic; }
.ws-trace-summary-prompt {
  margin-top: 10px !important; padding-top: 10px;
  border-top: 1px solid rgba(184,112,42,0.18);
  color: var(--ws-ink-2);
}
.ws-trace-outcome {
  margin: 16px 0; background: var(--ws-soft); border-radius: var(--ws-r-md);
  padding: 14px 16px;
}
.ws-trace-outcome .ws-trace-section-head { margin-bottom: 6px; }
.ws-trace-outcome .ws-outcome-summary { font-size: 13.5px; }
.ws-trace-reply {
  margin: 16px 0; background: var(--ws-soft); border-radius: var(--ws-r-md);
  padding: 14px 16px;
}
.ws-trace-reply .ws-trace-section-head { margin-bottom: 6px; }
.ws-trace-reply-body {
  margin: 0; font-size: 13.5px; line-height: 1.55; color: var(--ws-ink-1);
  white-space: pre-wrap; word-break: break-word;
}
.ws-trace-preview-wrap { margin: 18px 0; display: flex; flex-direction: column; gap: 8px; }
.ws-trace-preview {
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  padding: 12px 14px;
}
.ws-trace-preview-headline {
  font-size: 13.5px; font-weight: 600; color: var(--ws-ink);
  margin-bottom: 8px;
}
.ws-trace-preview-empty {
  font-size: 12.5px; color: var(--ws-ink-4); font-style: italic;
}
.ws-trace-preview-rows {
  display: flex; flex-direction: column; gap: 4px;
}
.ws-trace-preview-row {
  display: grid; grid-template-columns: minmax(110px, 22%) 1fr; gap: 10px;
  font-size: 12.5px; line-height: 1.5;
}
.ws-trace-preview--collapsed {
  display: flex; align-items: center; gap: 8px; cursor: pointer;
  width: 100%; text-align: left;
}
.ws-trace-preview--collapsed .ws-trace-preview-headline {
  margin-bottom: 0; font-size: 13px; white-space: nowrap;
  overflow: hidden; text-overflow: ellipsis;
}
.ws-trace-preview-collapse-btn {
  display: flex; align-items: center; gap: 6px;
  background: none; border: none; padding: 0; margin-bottom: 6px;
  font-size: 12px; font-weight: 600; color: var(--ws-ink-3);
  cursor: pointer;
}
.ws-trace-preview-collapse-btn:hover { color: var(--ws-ink); }
.ws-trace-preview-key { color: var(--ws-ink-4); text-transform: capitalize; }
/* Loop targets (selectedIds) — these aren't editable fields like the rest;
 * they're the records we'll iterate. Distinct treatment so users don't
 * mistake them for a per-record property. */
.ws-trace-preview-targets {
  display: flex; flex-direction: column; gap: 6px;
  margin: 4px 0 10px;
  padding: 8px 10px;
  background: rgba(60, 109, 182, 0.06);
  border: 1px dashed rgba(60, 109, 182, 0.35);
  border-radius: var(--ws-r-sm);
}
.ws-trace-preview-targets-head {
  display: flex; align-items: center; gap: 6px;
  font-size: 11px; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--ws-info, #3c6db6);
}
.ws-trace-preview-targets-icon { width: 12px; height: 12px; flex-shrink: 0; }
.ws-trace-preview-targets-label { line-height: 1; }
.ws-trace-preview-targets-ids {
  display: flex; flex-wrap: wrap; gap: 4px 5px;
  font-variant-numeric: tabular-nums;
}
.ws-trace-preview-target-chip {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 1px 7px;
  font-size: 11.5px;
  background: var(--ws-panel);
  border: 1px solid rgba(60, 109, 182, 0.25);
  border-radius: 3px;
  color: var(--ws-ink-2);
}
.ws-trace-preview-target-chip-name { color: var(--ws-ink); }
.ws-trace-preview-target-chip-id { color: var(--ws-ink-4); font-size: 10.5px; }
.ws-trace-preview-target-chip--more {
  font-weight: 600;
  color: var(--ws-info, #3c6db6);
  background: transparent;
  border-color: transparent;
}
.ws-trace-preview-val {
  color: var(--ws-ink-2); white-space: pre-wrap; overflow-wrap: anywhere;
}
.ws-trace-preview-val.is-editable {
  cursor: pointer; border-radius: 3px; padding: 1px 4px; margin: -1px -4px;
  transition: background 120ms;
}
.ws-trace-preview-val.is-editable:hover { background: rgba(19,17,14,0.06); }

/* Inline field editors */
.ws-inline-edit-cell { min-width: 0; position: relative; }
.ws-inline-edit-input {
  width: 100%; font-size: 12.5px; font-family: inherit;
  padding: 3px 6px; border: 1px solid var(--ws-line-2); border-radius: 4px;
  background: var(--ws-panel); color: var(--ws-ink);
  outline: none;
}
.ws-inline-edit-input:focus { border-color: var(--ws-accent); box-shadow: 0 0 0 2px rgba(19,17,14,0.08); }

/* Entity reference search editor */
.ws-inline-ref-editor { position: relative; }
.ws-inline-ref-input-row { display: flex; gap: 4px; align-items: center; }
.ws-inline-ref-clear {
  display: flex; align-items: center; justify-content: center;
  width: 22px; height: 22px; border: none; border-radius: 3px;
  background: none; color: var(--ws-ink-4); cursor: pointer; flex-shrink: 0;
}
.ws-inline-ref-clear:hover { background: var(--ws-hover); color: var(--ws-ink); }
.ws-inline-ref-dropdown {
  position: absolute; top: 100%; left: 0; right: 0; z-index: 20;
  max-height: 180px; overflow-y: auto;
  background: var(--ws-panel); border: 1px solid var(--ws-line-2);
  border-radius: 6px; margin-top: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.ws-inline-ref-row {
  display: block; width: 100%; text-align: left;
  padding: 6px 10px; font-size: 12.5px; color: var(--ws-ink);
  border: none; background: none; cursor: pointer;
}
.ws-inline-ref-row:hover { background: var(--ws-hover); }
.ws-inline-ref-row.is-selected { font-weight: 600; }
.ws-inline-ref-row--muted { color: var(--ws-ink-4); cursor: default; font-style: italic; }
.ws-inline-ref-row--muted:hover { background: none; }
.ws-inline-ref-tags { display: flex; flex-wrap: wrap; gap: 4px; margin-bottom: 4px; }
.ws-inline-ref-tag {
  display: inline-flex; align-items: center; gap: 3px;
  font-size: 11.5px; padding: 2px 6px; border-radius: 4px;
  background: var(--ws-soft); color: var(--ws-ink-2); border: 1px solid var(--ws-line);
}
.ws-inline-ref-tag-x {
  display: inline-flex; border: none; background: none; padding: 0;
  color: var(--ws-ink-4); cursor: pointer;
}
.ws-inline-ref-tag-x:hover { color: var(--ws-ink); }
.ws-trace-comments { display: flex; flex-direction: column; gap: 12px; margin: 18px 0; }
.ws-trace-comment {
  background: var(--ws-soft); border-radius: var(--ws-r-md);
  padding: 12px 14px;
}
.ws-trace-comment-header {
  display: flex; align-items: center; gap: 8px; margin-bottom: 8px;
}
.ws-trace-comment-author {
  font-size: 12px; font-weight: 600; color: var(--ws-ink-3);
}
.ws-trace-comment-time {
  font-size: 11px; color: var(--ws-ink-4); margin-left: auto;
}
.ws-trace-comment-body {
  font-size: 13.5px; line-height: 1.6; color: var(--ws-ink-1);
  white-space: pre-wrap; word-break: break-word;
}
.ws-trace-comment-truncated {
  display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;
  overflow: hidden;
}
.ws-trace-comment-toggle {
  background: none; border: none; padding: 0; margin-top: 4px;
  cursor: pointer; font-size: 12px; font-weight: 500; color: var(--ws-ink-4);
}
.ws-trace-comment-toggle:hover { color: var(--ws-ink-2); }
.ws-trace-section-toggle {
  display: flex; align-items: center; gap: 4px;
  background: none; border: none; padding: 0; margin: 0;
  cursor: pointer; font-size: 11px; font-weight: 600; letter-spacing: 0.06em;
  text-transform: uppercase; color: var(--ws-ink-4);
}
.ws-trace-section-toggle:hover { color: var(--ws-ink-2); }
.ws-trace-timeline-wrap { margin-top: 18px; }
.ws-trace-attachments { margin: 16px 0; }
.ws-trace-attachment-list { display: flex; flex-direction: column; gap: 2px; margin-top: 8px; }
.ws-trace-attachment-item {
  display: flex; align-items: center; gap: 10px; padding: 8px 10px;
  border-radius: var(--ws-r-sm); text-decoration: none; color: var(--ws-ink);
  transition: background 0.12s;
}
.ws-trace-attachment-item:hover { background: var(--ws-panel-hover); }
.ws-trace-attachment-info { display: flex; flex-direction: column; flex: 1; min-width: 0; }
.ws-trace-attachment-name {
  font-size: 12.5px; font-weight: 500; white-space: nowrap;
  overflow: hidden; text-overflow: ellipsis;
}
.ws-trace-attachment-size { font-size: 11px; color: var(--ws-ink-4); }
.ws-trace-attachment-thumb {
  width: 36px; height: 36px; border-radius: 7px;
  object-fit: cover; flex-shrink: 0;
  border: 1px solid var(--ws-line);
  background: var(--ws-soft);
}
.ws-trace-loading, .ws-trace-empty, .ws-trace-error {
  padding: 18px 20px; font-size: 13px; color: var(--ws-ink-4); text-align: center;
}
.ws-trace-error { color: var(--ws-err); }
.ws-trace-footer {
  display: flex; gap: 10px; padding: 14px 20px;
  border-top: 1px solid var(--ws-line); background: var(--ws-bg);
}
.ws-trace-reply-footer {
  display: flex; flex-direction: column; gap: 10px; padding: 14px 20px;
  border-top: 1px solid var(--ws-line); background: var(--ws-bg);
}
.ws-trace-reply-input {
  width: 100%; resize: vertical; min-height: 48px; max-height: 160px;
  padding: 10px 12px; border: 1px solid var(--ws-line-2); border-radius: var(--ws-r-sm);
  font-family: var(--ws-sans); font-size: 13px; line-height: 1.5;
  color: var(--ws-ink); background: var(--ws-panel);
  transition: border-color 0.15s;
}
.ws-trace-reply-input:focus {
  outline: none; border-color: var(--ws-ink-4);
}
.ws-trace-reply-input::placeholder { color: var(--ws-ink-5); }
.ws-trace-reply-input:disabled { opacity: 0.5; }
.ws-trace-reply-send { align-self: flex-end; }
.ws-trace-proposals {
  display: flex; flex-direction: column; gap: 8px;
  margin: 18px 0;
  padding: 14px 14px 12px;
  background: rgba(207, 140, 52, 0.06);
  border: 1px solid rgba(207, 140, 52, 0.28);
  border-radius: var(--ws-r-md);
}
.ws-trace-proposals .ws-trace-section-head {
  margin-bottom: 6px;
  color: var(--ws-warn, #cf8c34);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  display: flex; align-items: center; gap: 6px;
}
.ws-trace-proposals .ws-trace-section-head::before {
  content: "";
  display: inline-block;
  width: 8px; height: 8px;
  border-radius: 50%;
  background: var(--ws-warn, #cf8c34);
  box-shadow: 0 0 0 3px rgba(207, 140, 52, 0.18);
}
.ws-trace-proposal-list {
  display: flex; flex-direction: column; gap: 0;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md);
  background: var(--ws-panel);
  overflow: hidden;
}
.ws-prop-card {
  display: flex; flex-direction: column;
  background: var(--ws-panel);
  border-bottom: 1px solid var(--ws-line);
}
.ws-prop-card:last-child { border-bottom: 0; }

/* Small, square-ish buttons used in proposal cards.
   Selector is doubled to win the cascade against later .ws-btn rules
   defined elsewhere in this file. */
.ws-btn.ws-prop-mini-btn {
  padding: 4px 10px;
  font-size: 12px;
  gap: 5px;
  border-radius: var(--ws-r-sm);
  line-height: 1;
}
.ws-btn.ws-prop-icon-btn { padding: 4px 6px; }

.ws-prop-card--compact {
  display: flex; flex-direction: row; align-items: flex-start; gap: 12px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.12s ease;
  position: relative;
}
.ws-prop-card--compact:hover { background: var(--ws-bg); }
.ws-prop-card--compact:focus-visible {
  outline: 2px solid var(--ws-line-2); outline-offset: -2px;
}
.ws-prop-card--compact > svg { margin-top: 1px; }
.ws-prop-card-summary {
  flex: 1 1 auto; min-width: 0;
  display: flex; flex-direction: column; gap: 4px;
}
.ws-prop-card-title-row {
  display: flex; align-items: center; gap: 10px;
  min-height: 24px;
}
.ws-prop-card-title {
  flex: 1 1 auto; min-width: 0;
  font-size: 13.5px; font-weight: 600; color: var(--ws-ink);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.ws-prop-card-meta {
  display: flex; align-items: center; gap: 6px; flex-wrap: wrap;
  font-size: 12.5px; color: var(--ws-ink-4);
}
.ws-prop-card-chip { display: inline; }
.ws-prop-card-chip + .ws-prop-card-chip::before {
  content: "·"; margin: 0 4px; color: var(--ws-ink-4);
}
.ws-prop-card-typepill {
  display: inline-flex; align-items: center;
  padding: 2px 8px; margin-left: 4px;
  background: var(--ws-soft); color: var(--ws-ink-3);
  border-radius: 999px; font-size: 11.5px; font-weight: 500;
  white-space: nowrap;
}
.ws-prop-card-status {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 2px 8px;
  border-radius: 999px; font-size: 11.5px; font-weight: 500;
  white-space: nowrap; flex-shrink: 0;
}
.ws-prop-card-status--pending { background: rgba(207,140,52,0.10); color: var(--ws-warn, #cf8c34); }
.ws-prop-card-status--saving  { background: rgba(60,109,182,0.10); color: var(--ws-info, #3c6db6); }
.ws-prop-card-status--ok      { background: rgba(47,122,78,0.10);  color: var(--ws-ok, #2f7a4e); }
.ws-prop-card-status--muted   { background: var(--ws-soft);        color: var(--ws-ink-4); }
.ws-prop-card-status--error   { background: rgba(178,52,52,0.10);  color: var(--ws-err, #b23434); }
.ws-prop-card-hover-actions {
  display: flex; gap: 6px; flex-shrink: 0;
  opacity: 0; transform: translateX(4px);
  transition: opacity 0.12s ease, transform 0.12s ease;
  pointer-events: none;
}
.ws-prop-card--compact:hover .ws-prop-card-hover-actions,
.ws-prop-card--compact:focus-within .ws-prop-card-hover-actions {
  opacity: 1; transform: translateX(0);
  pointer-events: auto;
}

/* Expanded — tint + thicker bottom separator so it's easy to see
   where the active card ends when it sits in the list */
.ws-prop-card--expanded {
  background: var(--ws-bg);
  padding: 0;
  border-bottom-color: var(--ws-line-2);
}
.ws-prop-card-head {
  display: flex; align-items: center; gap: 12px;
  padding: 12px 14px 8px;
  width: 100%;
  background: transparent; border: 0;
  font-family: inherit; text-align: left;
  cursor: pointer;
  transition: background 0.12s ease;
}
.ws-prop-card-head:hover { background: rgba(15, 30, 47, 0.025); }
.ws-prop-card-head .ws-prop-card-title { flex: 1 1 auto; }
.ws-prop-card-collapse {
  padding: 4px;
  border-radius: var(--ws-r-sm);
  color: var(--ws-ink-4);
  display: inline-flex; align-items: center; justify-content: center;
}
.ws-prop-card-head:hover .ws-prop-card-collapse { color: var(--ws-ink); }
.ws-prop-card-header-action { display: inline-flex; align-items: center; }
.ws-prop-card-header-action > * { pointer-events: auto; }
/* Section for an approval that has been resolved — full-bleed tinted band
 * across the drawer width so it reads as a distinct "done" state, mirroring
 * the amber pending band but in the ok-green tone. */
.ws-trace-resolved {
  display: flex; flex-direction: column; gap: 10px;
  /* Bleed past the .ws-trace-body horizontal padding (20px) to hit the
   * drawer edges. Vertical padding gives the card breathing room. */
  margin: 18px -20px;
  padding: 14px 20px 16px;
  background: rgba(47, 122, 78, 0.06);
  border-top: 1px solid rgba(47, 122, 78, 0.20);
  border-bottom: 1px solid rgba(47, 122, 78, 0.20);
}
.ws-trace-resolved-head {
  font-size: 12px; font-weight: 700;
  letter-spacing: 0.06em; text-transform: uppercase;
  color: var(--ws-ok, #2f7a4e);
  display: inline-flex; align-items: center; gap: 6px;
}
.ws-trace-resolved-head::before {
  content: "";
  display: inline-block;
  width: 8px; height: 8px;
  border-radius: 50%;
  background: var(--ws-ok, #2f7a4e);
  box-shadow: 0 0 0 3px rgba(47, 122, 78, 0.16);
}
.ws-prop-card-body {
  padding: 4px 14px 12px;
}
.ws-prop-card-body .ws-trace-preview {
  border: 0;
  background: transparent;
  padding: 0;
}
.ws-prop-card-body .ws-trace-preview-headline { display: none; }
.ws-prop-card-note { padding: 0 14px 12px; }
.ws-prop-card-note-input {
  width: 100%;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  padding: 10px 12px;
  font-family: var(--ws-sans); font-size: 13px; color: var(--ws-ink);
  background: var(--ws-panel);
  resize: vertical;
  min-height: 70px;
}
.ws-prop-card-note-input:focus {
  outline: none; border-color: var(--ws-ink-3);
}
.ws-prop-card-actions {
  display: flex; gap: 6px; justify-content: flex-end;
  padding: 10px 14px;
  border-top: 1px solid var(--ws-line);
  background: var(--ws-panel);
}
.ws-trace-approval-footer {
  display: flex; flex-direction: column; gap: 10px; padding: 14px 20px;
  border-top: 1px solid var(--ws-line); background: var(--ws-bg);
}
.ws-trace-approval-footer--failed {
  background: rgba(178,52,52,0.04);
}
.ws-trace-approval-failure {
  display: flex; align-items: center; gap: 8px;
  font-size: 12.5px; color: var(--ws-err); font-weight: 500;
}
.ws-trace-approval-toggle {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  width: 100%; padding: 10px 12px; border-radius: var(--ws-r-sm);
  background: rgba(47,122,78,0.05); border: 1px solid rgba(47,122,78,0.12);
  cursor: pointer; font-family: var(--ws-sans); text-align: left;
}
.ws-trace-approval-toggle:hover { background: rgba(47,122,78,0.08); }
.ws-trace-approval-label {
  font-size: 11px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.04em; color: var(--ws-ok); margin-right: auto;
}
.ws-trace-approval-chips { display: flex; flex-wrap: wrap; gap: 5px; min-width: 0; flex: 1 1 100%; }
.ws-trace-approval-chip {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 3px 8px; border-radius: 999px; font-size: 11.5px; font-weight: 500;
  background: rgba(47,122,78,0.10); color: var(--ws-ok);
  white-space: nowrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis;
  min-width: 0;
}
.ws-trace-approval-detail-wrap {
  border: 1px solid var(--ws-line); border-radius: var(--ws-r-sm);
  overflow: hidden;
  padding: 12px;
  display: flex; flex-direction: column; gap: 12px;
  background: var(--ws-panel);
}
.ws-trace-approval-detail {
  margin: 0; font-size: 13px; line-height: 1.5; color: var(--ws-ink-1);
}
.ws-trace-approval-actions {
  display: flex; gap: 10px; flex-wrap: wrap;
  justify-content: flex-end;
}
.ws-trace-approval-header {
  display: flex; align-items: center;
  padding: 8px 4px;
}
.ws-trace-approval-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex; flex-direction: column; gap: 6px;
}
.ws-trace-approval-item {
  border: 1px solid rgba(47,122,78,0.16);
  border-radius: var(--ws-r-sm);
  background: rgba(47,122,78,0.04);
  overflow: hidden;
  transition: background 120ms ease;
}
.ws-trace-approval-item.is-open {
  background: var(--ws-panel);
}
.ws-trace-approval-row {
  width: 100%;
  display: flex; align-items: center; gap: 8px;
  padding: 8px 10px;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
  font-family: var(--ws-sans);
  font-size: 12.5px;
  color: var(--ws-ink-1);
  transition: background 120ms ease;
  min-width: 0;
}
.ws-trace-approval-row:hover {
  background: rgba(47,122,78,0.08);
}
.ws-trace-approval-item.is-open .ws-trace-approval-row {
  border-bottom: 1px solid var(--ws-line);
}
.ws-trace-approval-row > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ws-trace-approval-item .ws-trace-approval-detail-wrap {
  border: none;
  border-radius: 0;
  background: var(--ws-panel);
}
.ws-trace-question-block {
  padding: 10px 12px; border-radius: var(--ws-r-sm);
  background: rgba(184,112,42,0.06); border: 1px solid rgba(184,112,42,0.12);
}
.ws-trace-question-text {
  margin: 0; font-size: 13px; line-height: 1.5; font-weight: 500;
  color: var(--ws-ink-1);
}
.ws-trace-question-options {
  display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px;
}
.ws-trace-option-btn {
  background: var(--ws-panel) !important; border: 1px solid var(--ws-line-2) !important;
  font-weight: 500 !important;
}
.ws-trace-option-btn:hover:not(:disabled) {
  background: var(--ws-soft) !important; border-color: var(--ws-ink-4) !important;
}

/* Stats row */
.ws-trace-stats-row {
  display: grid; grid-template-columns: repeat(4, 1fr);
  gap: 1px; background: var(--ws-line);
  border: 1px solid var(--ws-line);
  border-radius: 8px; overflow: hidden;
  margin: 16px 0;
}
.ws-trace-stats-card {
  display: flex; align-items: baseline; gap: 8px;
  padding: 5px 12px;
  background: var(--ws-panel);
}
.ws-trace-stats-label {
  font-size: 10px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.06em; color: var(--ws-ink-4);
}
.ws-trace-stats-value {
  font-size: 13px; font-weight: 500;
  color: var(--ws-ink); font-variant-numeric: tabular-nums;
}

/* Activity trace */
.ws-trace-activity { margin-top: 18px; }
.ws-trace-activity-header {
  display: flex; align-items: center; justify-content: space-between;
  height: 28px; box-sizing: border-box;
  margin-bottom: 14px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--ws-line);
}
.ws-trace-expand-group {
  display: flex; align-items: center; gap: 4px; margin-left: auto;
}
.ws-trace-expand-toggle {
  display: inline-flex; align-items: center; gap: 4px;
  background: none; border: none; padding: 4px 8px; margin: 0;
  cursor: pointer; font-size: 11px; font-weight: 500;
  color: var(--ws-ink-3); border-radius: 5px;
  font-family: var(--ws-sans);
}
.ws-trace-expand-toggle:hover { color: var(--ws-ink); background: var(--ws-soft); }
.ws-trace-activity-scroll { overflow-y: auto; scrollbar-gutter: stable; }

/* Timeline steps */
.ws-trace-ev-list {
  list-style: none; padding: 0; margin: 0;
  display: flex; flex-direction: column;
}
.ws-trace-step {
  display: grid; grid-template-columns: 22px 1fr; gap: 10px;
  padding: 8px 0;
  position: relative;
  animation: ws-slide-in 0.2s ease;
}
.ws-trace-step.is-queued { opacity: 0.55; }
.ws-trace-step.is-queued .ws-trace-label { color: var(--ws-ink-4); }
@keyframes ws-slide-in {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Rail: dot + connecting line */
.ws-trace-rail {
  position: relative;
  display: flex; flex-direction: column; align-items: center;
}
.ws-trace-dot {
  width: 22px; height: 22px; border-radius: 50%;
  background: var(--ws-panel);
  border: 1.5px solid var(--ws-ink-5);
  display: inline-flex; align-items: center; justify-content: center;
  color: var(--ws-ink-3);
  flex-shrink: 0;
  z-index: 1;
}
.ws-trace-dot svg { width: 9px; height: 9px; }
.ws-trace-dot--tool { background: var(--ws-panel); border-color: var(--ws-ink-3); color: var(--ws-ink-2); }
.ws-trace-dot--done { background: #E8F0EA; border-color: #8FB89A; color: #5A8C68; }
.ws-trace-dot--streaming {
  background: var(--ws-info); border-color: var(--ws-info); color: white;
  box-shadow: 0 0 0 3px rgba(59,107,168,0.2);
  animation: ws-dot-glow 1.4s infinite;
}
@keyframes ws-dot-glow {
  0%, 100% { box-shadow: 0 0 0 0 rgba(59,107,168,0.4); }
  50% { box-shadow: 0 0 0 5px rgba(59,107,168,0); }
}
.ws-trace-dot--queued { border-style: dashed; opacity: 0.55; }
.ws-trace-dot--handoff { background: #C68A48; border-color: #C68A48; color: white; }
.ws-trace-dot--reasoning { background: #8C6BB1; border-color: #8C6BB1; color: white; }
.ws-trace-dot--spawn { background: var(--ws-ink); border-color: var(--ws-ink); color: white; }
.ws-trace-dot--error { background: var(--ws-err); border-color: var(--ws-err); color: white; }
.ws-trace-dot--approval { background: #D97706; border-color: #D97706; color: white; }
.ws-trace-dot--write { background: var(--ws-panel); border-color: var(--ws-info); color: var(--ws-info); }
.ws-trace-dot--thought { background: #8C6BB1; border-color: #8C6BB1; color: white; }
.ws-trace-dot--plan { background: #8C6BB1; border-color: #8C6BB1; color: white; }
.ws-trace-dot--plan-step { background: var(--ws-panel); border-color: var(--ws-ink-5); color: var(--ws-ink-3); }
.ws-trace-dot--plan-done { background: #E8F0EA; border-color: #8FB89A; color: #5A8C68; }
.ws-trace-dot--comment { background: var(--ws-panel); border-color: var(--ws-ink-4); color: var(--ws-ink-3); }

.ws-trace-step.is-plan-step { margin-left: 0; }
.ws-trace-step.is-group-child { padding: 2px 0; }
.ws-trace-step.is-group-child .ws-trace-dot { width: 16px; height: 16px; }
.ws-trace-step.is-group-child .ws-trace-dot svg { width: 7px; height: 7px; }
.ws-trace-step.is-group-child .ws-trace-head { font-size: 12px; }

.ws-trace-line {
  position: absolute;
  top: 22px; bottom: -8px;
  left: 50%; transform: translateX(-50%);
  width: 1.5px;
  background: var(--ws-line);
}
.ws-trace-step.is-streaming .ws-trace-line {
  background: linear-gradient(180deg, var(--ws-info), var(--ws-line) 80%);
}

/* Event body: head + label + detail */
.ws-trace-ev-body {
  min-width: 0; padding-top: 1px;
  display: flex; flex-direction: column; gap: 4px;
}
.ws-trace-head {
  display: flex; flex-wrap: nowrap; align-items: center; gap: 6px;
  font-size: 12.5px; min-width: 0;
}
.ws-trace-action { color: var(--ws-ink-3); white-space: nowrap; flex-shrink: 0; }
.ws-trace-system-label {
  font-size: 10px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.04em; color: var(--ws-ink-4);
  padding: 1px 6px; border-radius: 4px;
  background: var(--ws-soft); border: 1px solid var(--ws-line);
  flex-shrink: 0;
}
.ws-trace-actor-name { font-weight: 600; color: var(--ws-ink-2); font-size: 12.5px; white-space: nowrap; flex-shrink: 0; }
.ws-trace-head-label {
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  min-width: 0; flex: 1; color: var(--ws-ink-2);
}
.ws-trace-tool-name {
  font-family: var(--ws-mono); font-size: 11.5px;
  background: var(--ws-soft); padding: 1px 5px; border-radius: 4px;
  color: var(--ws-ink-2);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  flex: none;
}
.ws-trace-meta {
  display: flex; align-items: center; gap: 6px;
  margin-left: auto; flex-shrink: 0;
}
.ws-trace-time {
  font-family: var(--ws-mono); font-size: 10.5px;
  color: var(--ws-ink-4);
  font-variant-numeric: tabular-nums;
  white-space: nowrap; flex-shrink: 0;
}
.ws-trace-dur {
  font-family: var(--ws-mono); font-size: 10.5px;
  color: var(--ws-ink-4); font-variant-numeric: tabular-nums;
}

/* Status pill */
.ws-trace-pill {
  font-size: 9.5px; padding: 1px 6px; border-radius: 4px;
  font-weight: 500; white-space: nowrap;
  background: var(--ws-soft); color: var(--ws-ink-4);
  border: 1px solid var(--ws-line);
}
.ws-trace-pill--streaming {
  background: rgba(59,107,168,0.08); color: var(--ws-info);
  border-color: rgba(59,107,168,0.25);
}
.ws-trace-pill--ok {
  background: rgba(47,122,78,0.08); color: var(--ws-ok);
  border-color: rgba(47,122,78,0.25);
}
.ws-trace-pill--error {
  background: rgba(178,52,52,0.08); color: var(--ws-err);
  border-color: rgba(178,52,52,0.25);
}

/* Expand chevron */
/* Label (bigger text below head) */
.ws-trace-label {
  font-size: 13px; color: var(--ws-ink); font-weight: 500;
  margin-top: 2px; padding-right: 95px;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
  overflow: hidden;
}
.ws-trace-label.is-expandable,
.ws-trace-ev-detail.is-expandable { cursor: pointer; }
.ws-trace-ev-detail {
  font-size: 12px; color: var(--ws-ink-3); line-height: 1.5;
  padding-right: 95px;
}

/* Progress bar for streaming events */
.ws-trace-progress { display: flex; align-items: center; gap: 8px; margin-top: 6px; }
.ws-trace-progress-track {
  flex: 1; height: 4px;
  background: var(--ws-soft); border-radius: 2px;
  overflow: hidden;
}
.ws-trace-progress-fill {
  display: block; height: 100%;
  background: var(--ws-info); border-radius: 2px;
  transition: width 300ms;
  animation: ws-progress-grow 3s ease-in-out infinite;
}
@keyframes ws-progress-grow {
  0% { width: 30%; }
  50% { width: 70%; }
  100% { width: 30%; }
}

/* IO block (expandable input/output) */
.ws-trace-io {
  margin-top: 8px;
  background: var(--ws-soft);
  border: 1px solid var(--ws-line);
  border-radius: 7px;
  overflow: hidden;
}
.ws-trace-io-block { padding: 8px 10px; }
.ws-trace-io-block + .ws-trace-io-block { border-top: 1px dashed var(--ws-line); }
.ws-trace-io-key {
  font-size: 9.5px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--ws-ink-4);
  margin-bottom: 3px;
}
.ws-trace-io-val {
  font-size: 11.5px; color: var(--ws-ink-2);
  line-height: 1.5; word-break: break-word; white-space: pre-wrap;
}
.ws-trace-io-mono {
  font-family: var(--ws-mono); font-size: 11px; color: var(--ws-ink);
}
.ws-trace-thought-full {
  font-size: 12.5px; line-height: 1.55; color: var(--ws-ink-2);
  white-space: pre-wrap; word-break: break-word;
  margin-top: 4px; padding: 8px 10px;
  background: var(--ws-soft); border-radius: var(--ws-r-sm);
}
.ws-trace-md { white-space: normal; word-break: break-word; }
.ws-trace-md p { margin: 0 0 6px; }
.ws-trace-md p:last-child { margin-bottom: 0; }
.ws-trace-md ul, .ws-trace-md ol { margin: 4px 0; padding-left: 20px; }
.ws-trace-md li { margin-bottom: 2px; }
.ws-trace-md strong, .ws-trace-md b { font-weight: 600; color: var(--ws-ink); }
.ws-trace-md em, .ws-trace-md i { font-style: italic; }
.ws-trace-md a { color: var(--ws-accent, #2962ff); text-decoration: underline; }
.ws-trace-md code { font-family: var(--ws-mono); font-size: 11.5px; background: var(--ws-line); padding: 1px 4px; border-radius: 3px; }
.ws-trace-md h1, .ws-trace-md h2, .ws-trace-md h3, .ws-trace-md h4, .ws-trace-md h5, .ws-trace-md h6 {
  margin: 14px 0 6px; font-weight: 600; color: var(--ws-ink); line-height: 1.3;
}
.ws-trace-md h1:first-child, .ws-trace-md h2:first-child, .ws-trace-md h3:first-child,
.ws-trace-md h4:first-child, .ws-trace-md h5:first-child, .ws-trace-md h6:first-child { margin-top: 0; }
.ws-trace-md h1 { font-size: 16px; }
.ws-trace-md h2 { font-size: 15px; }
.ws-trace-md h3 { font-size: 13.5px; }
.ws-trace-md h4, .ws-trace-md h5, .ws-trace-md h6 { font-size: 13px; }
.ws-trace-md hr { border: 0; border-top: 1px solid var(--ws-line); margin: 12px 0; }
.ws-trace-md blockquote {
  margin: 6px 0; padding: 4px 10px; color: var(--ws-ink-3);
  border-left: 2px solid var(--ws-line); background: var(--ws-soft);
}
.ws-trace-md pre {
  margin: 6px 0; padding: 8px 10px; background: var(--ws-line);
  border-radius: var(--ws-r-sm); overflow-x: auto;
  font-family: var(--ws-mono); font-size: 11.5px; line-height: 1.5;
}
.ws-trace-md pre code { background: transparent; padding: 0; font-size: inherit; }
.ws-trace-md table {
  border-collapse: collapse; margin: 8px 0; font-size: 12.5px;
  display: block; max-width: 100%; overflow-x: auto;
}
.ws-trace-md th, .ws-trace-md td {
  border: 1px solid var(--ws-line); padding: 5px 8px; text-align: left; vertical-align: top;
}
.ws-trace-md th { background: var(--ws-soft); font-weight: 600; color: var(--ws-ink); }

/* Plan section (standalone, always visible) */
.ws-trace-plan-section {
  margin-bottom: 16px;
}
.ws-trace-plan-checklist {
  display: flex; flex-direction: column;
  border: 1px solid var(--ws-line); border-radius: 7px;
  overflow: hidden;
}
.ws-trace-plan-check-row {
  display: flex; align-items: center; gap: 8px;
  padding: 7px 10px;
  border-bottom: 1px solid var(--ws-line);
  font-size: 12.5px; color: var(--ws-ink-4);
  filter: blur(2.5px); user-select: none;
  transition: filter 0.3s, color 0.3s;
}
.ws-trace-plan-check-row:last-child { border-bottom: 0; }
.ws-trace-plan-check-row.is-done {
  filter: none; color: var(--ws-ink-2); user-select: auto;
}
.ws-trace-plan-check-icon {
  width: 16px; height: 16px; border-radius: 50%;
  border: 1.5px solid var(--ws-ink-5);
  background: var(--ws-panel);
  display: grid; place-items: center;
  flex-shrink: 0;
}
.ws-trace-plan-check-icon.done {
  background: var(--ws-ok); border-color: var(--ws-ok); color: white;
}
.ws-trace-plan-check-title { flex: 1; font-weight: 500; min-width: 0; }

/* Live banner */
.ws-trace-live-banner {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 14px; margin-top: 4px;
  background: rgba(59,107,168,0.06);
  border: 1px dashed rgba(59,107,168,0.3);
  border-radius: var(--ws-r-md);
  font-size: 11.5px; color: var(--ws-ink-3);
}

.ws-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 14px; border-radius: var(--ws-r-sm);
  font-size: 13px; font-weight: 500; cursor: pointer;
  border: 1px solid var(--ws-line); background: var(--ws-panel);
  color: var(--ws-ink); transition: background 0.12s, border-color 0.12s;
}
.ws-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.ws-btn-sm { padding: 5px 10px; font-size: 12px; }
.ws-btn-primary { background: var(--ws-ink); color: var(--ws-bg); border-color: var(--ws-ink); }
.ws-btn-primary:hover:not(:disabled) { background: #244856; }
.ws-btn-secondary { background: var(--ws-panel); }
.ws-btn-secondary:hover:not(:disabled) { background: var(--ws-hover); }
.ws-btn-danger { background: var(--ws-err); color: var(--ws-bg); border-color: var(--ws-err); }
.ws-btn-danger:hover:not(:disabled) { background: #a04438; }
.ws-btn-ghost { background: transparent; border-color: transparent; }
.ws-btn-ghost:hover:not(:disabled) { background: var(--ws-hover); }
`;
